import { Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SYSTEM_ACTIONS } from '../constants/ChatSystemActions';

const ChatSystemMessage = ({ message, participants = [] }) => {
  const { t } = useTranslation();
  const { metaData, senderId } = message || {};
  const messageKey =
    ACTION_TRANSLATIONS[metaData?.action] || ACTION_TRANSLATIONS.DEFAULT;
  const sender = participants.find((user) => user.id === senderId);
  const senderName = sender?.name || 'Unknown';

  return (
    <ContentStyle>
      <Typography variant="body2" textAlign="center">
        {t(messageKey, {
          name: senderName,
        })}
      </Typography>
    </ContentStyle>
  );
};

const ACTION_TRANSLATIONS = {
  [SYSTEM_ACTIONS.GROUP_JOIN]: 'chat.system.group_join_message',
  [SYSTEM_ACTIONS.GROUP_ENTRY]: 'chat.system.group_entry_message',
  [SYSTEM_ACTIONS.FINISHED_CONVERSATION]:
    'chat.system.finished_conversation_message',
  [SYSTEM_ACTIONS.VERIFICATION_REQUEST]:
    'chat.system.verification_request_message',
  [SYSTEM_ACTIONS.FALSE_ALARM_CONFIRMED]:
    'chat.system.false_alarm_confirmed_message',
  [SYSTEM_ACTIONS.DURESS_CONFIRMED]: 'chat.system.duress_confirmed_message',
  [SYSTEM_ACTIONS.VERIFICATION_INVALID_CODE]:
    'chat.system.verification_invalid_code_message',
  DEFAULT: 'chat.system.default_message',
};

const ContentStyle = styled('div')(({ theme }) => ({
  display: 'block',
  padding: theme.spacing(0.5),
  maxWidth: '60%',
  margin: `${theme.spacing(0.5)} auto ${theme.spacing(3)} auto`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral,
}));

export default ChatSystemMessage;
